import { useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { C, Btn, Card } from "../components/UI";

function ResultLayout({ icon, iconBg, title, titleColor, children }) {
  return (
    <div style={{ minHeight: "calc(100vh - 60px)", display: "flex", alignItems: "center", justifyContent: "center", background: `linear-gradient(135deg, ${C.rosePale} 0%, #faf9f7 60%)`, padding: 24 }}>
      <Card style={{ maxWidth: 440, width: "100%", padding: "48px 36px", textAlign: "center" }}>
        <div style={{ width: 80, height: 80, borderRadius: "50%", background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 36, margin: "0 auto 24px" }}>{icon}</div>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700, color: titleColor, marginBottom: 12 }}>{title}</h1>
        {children}
      </Card>
    </div>
  );
}

export function PaymentSuccess() {
  const navigate = useNavigate();
  const { setCompanyPlan } = useApp();
  const [params] = useSearchParams();
  const plan = params.get("plan") || "pro";

  // Em produção, valide o pagamento via backend antes de ativar o plano
  // O Mercado Pago envia: payment_id, status, external_reference via query params
  const paymentId = params.get("payment_id");
  const status = params.get("status");

  if (status === "approved") setCompanyPlan(plan);

  return (
    <ResultLayout icon="✓" iconBg={C.greenBg} title="Pagamento aprovado!" titleColor={C.green}>
      <p style={{ fontSize: 14, color: C.textSec, lineHeight: 1.7, marginBottom: 8 }}>
        Seu plano <strong>Pro</strong> está ativo. Bem-vinda ao WoMom!
      </p>
      {paymentId && (
        <div style={{ background: C.grayBg, borderRadius: 8, padding: "8px 14px", fontSize: 12, color: C.textSec, marginBottom: 20 }}>
          ID do pagamento: <code>{paymentId}</code>
        </div>
      )}
      <div style={{ background: C.greenBg, border: `0.5px solid ${C.greenBorder}`, borderRadius: 10, padding: "12px 16px", fontSize: 13, color: C.green, marginBottom: 24, textAlign: "left" }}>
        ✓ Acesso ao painel liberado<br />
        ✓ Perfil em processo de verificação<br />
        ✓ Você receberá um e-mail de confirmação
      </div>
      <Btn full onClick={() => navigate("/dashboard")}>Ir para o painel →</Btn>
    </ResultLayout>
  );
}

export function PaymentFailure() {
  const navigate = useNavigate();

  return (
    <ResultLayout icon="✗" iconBg={C.redBg} title="Pagamento não aprovado" titleColor={C.red}>
      <p style={{ fontSize: 14, color: C.textSec, lineHeight: 1.7, marginBottom: 20 }}>
        Não foi possível processar o pagamento. Isso pode acontecer por saldo insuficiente, dados incorretos ou limite do cartão.
      </p>
      <div style={{ background: C.grayBg, borderRadius: 10, padding: "14px 16px", fontSize: 13, color: C.textSec, marginBottom: 24, textAlign: "left", lineHeight: 1.7 }}>
        Sugestões:<br />
        · Verifique os dados do cartão<br />
        · Tente outro método de pagamento<br />
        · Entre em contato com seu banco
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <Btn variant="secondary" full onClick={() => navigate("/")}>Voltar ao início</Btn>
        <Btn full onClick={() => navigate("/planos")}>Tentar novamente</Btn>
      </div>
    </ResultLayout>
  );
}

export function PaymentPending() {
  const navigate = useNavigate();

  return (
    <ResultLayout icon="⏳" iconBg={C.amberBg} title="Pagamento em análise" titleColor={C.amber}>
      <p style={{ fontSize: 14, color: C.textSec, lineHeight: 1.7, marginBottom: 20 }}>
        Seu pagamento está sendo processado. Isso pode levar alguns minutos a horas, dependendo do método de pagamento escolhido.
      </p>
      <div style={{ background: C.amberBg, border: `0.5px solid #FAC775`, borderRadius: 10, padding: "12px 16px", fontSize: 13, color: C.amber, marginBottom: 24, textAlign: "left", lineHeight: 1.7 }}>
        ⏳ Para boleto bancário: até 3 dias úteis<br />
        ⏳ Para Pix: normalmente confirmado em minutos<br />
        ✉️ Você receberá um e-mail quando confirmado
      </div>
      <Btn full onClick={() => navigate("/")}>Entendido, voltar ao início</Btn>
    </ResultLayout>
  );
}
